import { useBFF } from '~/composables/useBFF/useBFF';

export default defineNuxtPlugin(async (nuxtApp) => {
  const { $featureFlags } = useBFF();

  const flags = useState<Flag[]>(`featureFlags-${useRequestURL().hostname}`, () => []);

  if (!flags.value?.length) {
    try {
      const { data } = await $featureFlags.getFeatureFlags();
      flags.value = data as Flag[] ?? [];
    }
    catch {
      flags.value = [];
    }
  }

  const featureFlags = {
    flags: flags.value,
    has(flag: Flag | Flag[]) {
      if (typeof flag === 'string') {
        return this.flags.includes(flag);
      }

      if (Array.isArray(flag)) {
        if (flag.some(f => typeof f !== 'string')) {
          throw new TypeError('Flags must be strings');
        }

        return flag.every(f => this.flags.includes(f));
      }

      return false;
    },
    hasnt(flag: Flag | Flag[]) {
      return !this.has(flag);
    },
  };

  nuxtApp.provide('flags', featureFlags);
});
